import { Button } from "@/components/ui/button";
import { ListPagination } from "@/types/list";
import { FC } from "react";
import { PerPageSelection } from "./PerPageSelection";

interface PaginationProps extends ListPagination {
	onPageChange?: (page: number) => void;
	onPerPageChange: (page: number) => void;
	className?: string;
	loading?: boolean;
}

export const Pagination: FC<PaginationProps> = ({
	page,
	pageSize,
	total,
	onPageChange,
	onPerPageChange,
	className = "",
	loading = false,
}) => {
	const loadingClass = loading ? "opacity-50" : "";
	return (
		<div className={`flex items-center justify-between gap-2 py-4 ${className}`}>
			<div className={`flex gap-2 items-center ${loadingClass}`}>
				Showing
				<PerPageSelection total={total} perPage={pageSize} setPerPage={onPerPageChange} loading={loading} />
				of
				<span className="font-semibold">{loading ? "..." : total}</span>
			</div>
			<div className="flex items-center justify-end gap-2 py-4">
				<Button
					variant="outline"
					size="sm"
					onClick={() => onPageChange?.(page - 1)}
					disabled={page <= 0 || loading}
				>
					Previous
				</Button>
				<span className={`text-sm ${loadingClass}`}>
					Page {loading ? "..." : page + 1} of {loading ? "..." : Math.ceil(total / pageSize)}
				</span>
				<Button
					variant="outline"
					size="sm"
					onClick={() => onPageChange?.(page + 1)}
					disabled={page >= Math.ceil(total / pageSize) - 1 || loading}
				>
					Next
				</Button>
			</div>
		</div>
	);
};
